export default __webpack_public_path__ + "static/media/Essex_Icons_Family.18025a1b.svg";